import { combineReducers } from "redux";
import openReducer from "./openReducer";
import connectionReducer from "./connetionReducer";
import authReducer from "./authReducer";
import myBatteriesReducer from "./myBatteriesReducer";
import allBatteriesReducer from "./allBatteriesReducer";
import allUsersReducer from "./allUsersReducer";
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import historyReducer from "./historyReducer";
import batteryByIdReducer from "./batteryByIdReducer"
import userByIdReducer from "./userByIdReducer";

const authPersistConfig = {
    key: "auth",
    storage,
    blacklist: ['error', 'fetching']
}

const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    open: openReducer,
    connection: connectionReducer,
    myBatteries: myBatteriesReducer,
    allBatteries: allBatteriesReducer,
    batteryById: batteryByIdReducer,
    history: historyReducer,
    allUsers: allUsersReducer,
    userById: userByIdReducer
})

export default rootReducer